function initSlideshowLinks() {
  document.querySelectorAll('.slideshow__text-wrapper').forEach(function(el) {
    el.style.pointerEvents = 'none';
  });

  document.querySelectorAll('.slideshow__slide').forEach(function(slide) {
    var media = slide.querySelector('.slideshow__media[data-link]');
    if(media) {
      slide.style.cursor = 'pointer';
      slide.onclick = function(e) {
        window.location.href = media.getAttribute('data-link');
      };
    }
  });
}

initSlideshowLinks();
setTimeout(initSlideshowLinks, 500);
setTimeout(initSlideshowLinks, 1500);
setTimeout(initSlideshowLinks, 3000);
